"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const project_1 = require("../Abstract/Interfaces/project");
const SwichQR_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/SwichQR.vue"));
let ModalQRVisibility = class ModalQRVisibility extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.hasLoadingQRImg = false;
        this.statusVisibility = false;
    }
    mounted() {
        if (this.currentProject.certificate.is_public) {
            this.statusVisibility = true;
        }
    }
    close() {
        this.$emit('close');
    }
    async toggleVisibilityProject() {
        await this.currentProject.toggleVisibility();
        this.statusVisibility = !this.statusVisibility;
    }
    async downloadQRImg() {
        this.hasLoadingQRImg = true;
        await this.currentProject.downloadQRImg();
        this.hasLoadingQRImg = false;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: project_1.AreaProjectDeliverable, default: new project_1.AreaProjectDeliverable({}) })
], ModalQRVisibility.prototype, "currentProject", void 0);
ModalQRVisibility = __decorate([
    (0, vue_property_decorator_1.Options)({ components: { Modal: bmk_ui_framework_1.Modal, Button: bmk_ui_framework_1.Button, SwichQR: SwichQR_vue_1.default } })
], ModalQRVisibility);
exports.default = ModalQRVisibility;
